<div
  class="range-slider-knob"
  [class.range-slider-knob--is-dragging]="dragState.isDragging"
  #knob
  [style.transform]="transform"
  (mousedown)="onDragStart($event)"
  (touchstart)="onDragStart($event)"
></div>

<div
  class="range-slider-knob__overlay"
  [class.range-slider-knob__overlay--open]="dragState.isDragging"
></div>
